import ImageHotSpotsToolTip from './component'
export default ImageHotSpotsToolTip
